<!--
고정값 출력
  히든변수와 텍스트 출력으로 구성되어있다.
  입력값  수정없이 항상 고정된 값이 전달하는경우에 사용함
------------------------------------
사용 예 )
------------------------------------
값 바인딩 : 일반 바인딩
    <app-input-fixed
        name="히든변수네임"
        value="히든변수값"

        text="화면에표시될 텍스트"
    > </app-input-fixed>

------------------------------------
지원하지 않는 기능
    placeholder : 항상 고정값이기때문에 placeholder가 의미없음
    focus
    focusout

-->
<template>
    <div :class="classObject" :style="[defaultCssVariables, cssVariables]">
        <div
                class="fixed"
                :class=" inputSizeClass"
        >
            {{ text }}
        </div>

        <input 
            type="hidden"

            :id="id"
            :name="name"

            :value="value"
            @input="updateValue"
        />

    </div>
</template>

<script>
    import InputBase from './base.vue';
    export default {
        extends: InputBase,
        props: {
            text: String
        }
    }
</script>